import { createCommand } from '../bridge-api-command-creator';
import type {
	CommandConstructor,
	CommandProperties,
	SerializableValue,
} from '../bridge-api-command-types';

/**
 * A command sent by a bridge API client to discover a specific client.
 *
 * @summary {@link CommandProperties.senderId} is sending a beacon for {@link CommandProperties.receiverId}.
 */
export const DiscoveryCommand: CommandConstructor<CommandProperties, SerializableValue> =
	createCommand('discovery-command');

/**
 * A command sent by a bridge API client in response to discovery attempts {@link DiscoveryCommand} from a specific client.
 *
 * @summary {@link CommandProperties.senderId} is responding to a beacon from {@link CommandProperties.receiverId}.
 */
export const ReachableCommand: CommandConstructor<CommandProperties, SerializableValue> =
	createCommand('reachable-command');

/**
 * A command sent by a bridge API client to notify all other clients that it is being torn down.
 *
 * @summary {@link CommandProperties.senderId} is notifying all clients that it is shutting down and should be removed from their registries.
 */
export const TeardownCommand: CommandConstructor<CommandProperties, SerializableValue> =
	createCommand('teardown-command');
